import * as React from "react";
import {connect} from "react-redux";
import {bindActionCreators} from "redux";

import {
  Notification,
    Pace
} from "components/Atoms";
import {Box, Container, Button} from "@mui/material";
import { H4, H5 } from "components/CustomTypography";
import { PhotoCamera } from '@mui/icons-material';

import * as Actions         from "actions/seller/seller.products";

import {useEffect, useState} from "react";
import PhotoUpload from "components/PhotoUpload";
import ModelTryOnSelector from "components/elements/seller/ModelTryOnSelector";

const PrivateProductImageMain = (props) => {

    const {
        serviceError, reqStatus,
        isLoading, product, cancelEdit,
        addPrivateProductImage, removePrivateProductImage,
        productImageList,
        getSystemModels,
        generateModelTryOn,
        systemModels,
        isLoadingModels,
        isGeneratingTryOn
    } = props;

    const {prod_id, name, images} = product;
    const [showModelSelector, setShowModelSelector] = useState(false);

    const sendNotification = (type, { title, description = "" }) => {
        Notification[type]({
            message: title,
            description,
        });
    };

    useEffect(() => {
        if (serviceError && reqStatus) {
            const feedback = {
                title: "Something went wrong!",
                description: serviceError.statusText,
            };
            sendNotification("error", feedback);
        }
        product.images = productImageList.images;
    }, [serviceError, reqStatus]);

    const handleOpenModelSelector = () => {
        if (!systemModels || systemModels.length === 0) {
            getSystemModels();
        }
        setShowModelSelector(true);
    };

    const handleCloseModelSelector = () => {
        setShowModelSelector(false);
    };

    const handleSelectModel = (model) => {
        generateModelTryOn(prod_id, model._id);
        setShowModelSelector(false);
    };


    const addImageCallback = (file) => {
        const formData = new FormData();
        formData.append("image", file);
        addPrivateProductImage(product.prod_id, formData);
    }

    const filter = (id) => {
        return images.filter(image => image.cdn.public_id !== id)
    }

    const removeImageCallback = (id) => {
        product.images = product.images.filter(image => image.cdn.public_id !== id);
        removePrivateProductImage(product.prod_id, id);
    }

    return (
        <Container>
            {isLoading && <Pace color="#27ae60" height="2px" progressbar="2px" />}
            <Box>
                <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                    <H5>Product Images</H5>
                    <Button
                        variant="contained"
                        color="primary"
                        startIcon={<PhotoCamera />}
                        onClick={handleOpenModelSelector}
                        disabled={!images || images.length === 0}
                    >
                        Generate with Model
                    </Button>
                </Box>
                
                {(!images || images.length === 0) && (
                    <Box mb={2} p={2} bgcolor="grey.100" borderRadius={1}>
                        <H5 fontSize={12} color="text.secondary">
                            Upload at least one product image to generate a virtual try-on with a model
                        </H5>
                    </Box>
                )}
                
                <PhotoUpload isRemoveAllowed={true}
                             keepFirstImage={true}
                             images={images}
                             addImageCallback={addImageCallback}
                             removeImageCallback={removeImageCallback}
                             cancelEdit={cancelEdit}
                />
            </Box>
            
            <ModelTryOnSelector
                open={showModelSelector}
                onClose={handleCloseModelSelector}
                onSelectModel={handleSelectModel}
                models={systemModels}
                loading={isLoadingModels}
                generating={isGeneratingTryOn}
            />
        </Container>
    );

};

// Mapping Props and State.
const _PrivateProductImageMain = connect(
    ({ products, bootupInfo }) => ({
      bootupInfo: bootupInfo,
      reqStatus: products.reqStatus,
      isLoading: products.isLoading,
      serviceError: products.serviceError,
      productImageList: products.productImageList,
      systemModels: products.systemModels,
      isLoadingModels: products.isLoadingModels,
      isGeneratingTryOn: products.isGeneratingTryOn,
    }),
    (dispatch) => bindActionCreators({ ...Actions }, dispatch)
)(PrivateProductImageMain);

export { _PrivateProductImageMain as default };
